package br.com.texeratx.boardgametimeapp.domain.usecases.games

import br.com.texeratx.boardgametimeapp.data.repository.GameRepository
import br.com.texeratx.boardgametimeapp.ui.screens.games.model.GameUI

class GetGamesUseCase(
    private val repository: GameRepository
) {
    suspend operator fun invoke(): Result<List<GameUI>> {
        val result = repository.getGames()

        return result.map { dtoList ->
            dtoList.map { dto ->
                GameUI(
                    id = dto.id,
                    name = dto.name,
                    imageUrl = dto.imageUrl ?: dto.thumbnailUrl,
                    minPlayers = dto.minNumberOfPlayers,
                    maxPlayers = dto.maxNumberOfPlayers,
                    duration = dto.gameDuration,
                    categoryId = null,
                    category = dto.categoryName,
                    modeId = null,
                    mode = dto.modeName,
                    bggUrl = dto.bggUrl,
                    manualUrl = dto.manualUrl,
                    spotifyUrl = dto.spotifyUrl,
                    matchesPlayed = dto.matchesPlayed,
                    clanId = dto.clanId
                )
            }
        }
    }
}


